import Noty from 'noty';

export default (form) => {
  const checkBox = form.querySelector('.js-subscribe-form-checkbox');
  const submitBtn = form.querySelector('.js-submit-btn');

  checkBox.onchange = function() {

    if(this.checked){
      submitBtn.disabled = false;

    } else {
      submitBtn.disabled = true;
    }
  };

  form.addEventListener('submit', e => {
    e.preventDefault();
    
    if(form.querySelector('.js-validate-robot').value !== '') { return false }

    const url = form.action;

    let data = '';
    const inputs = form.querySelectorAll('.js-form-input');

    let subscribeResponseError = document.getElementById('subscribeResponseError');
    let subscribeResponseSuccess = document.getElementById('subscribeResponseSuccess');
    let formStatusError = subscribeResponseError.querySelector('.formStatus');
    let formStatusSuccess = subscribeResponseSuccess.querySelector('.formStatus');

    // let popupPos = form.dataset.popup || 'topRight';

    inputs.forEach((input, i) => {
      data += `&${input.name}=${encodeURIComponent(input.value)}`;

      input.addEventListener('input', () => {
        form.classList.remove('error')
      })
    });

    const script = document.createElement('script');
    script.src = url + data;
    document.body.appendChild(script);

    const callback = 'callback';
    window[callback] = function(data) {
      delete window[callback];
      document.body.removeChild(script);

      // new Noty({
      //     text: data.msg,
      //     timeout: 5000,
      //     type: data.result,
      //     layout: popupPos
      // }).show();

      // if (data.result == 'success') {

      //   inputs.forEach(function(i) {
      //     i.value = '';
      //   });

      // }

      if (data.result == 'success') {

        form.classList.add('success');

        if(formStatusSuccess && subscribeResponseSuccess){
            subscribeResponseSuccess.classList.add('active');
            formStatusSuccess.innerHTML = data.msg;
            if(subscribeResponseError){
                subscribeResponseError.classList.remove('active');
            }
        }

        inputs.forEach(function(i) {
            i.value = '';
        });

        setTimeout(() => {
            form.classList.remove('success');
            if(formStatusSuccess && subscribeResponseSuccess){
                subscribeResponseSuccess.classList.remove('active');
                formStatusSuccess.innerHTML = '';
            }
        }, 5000);

    } else {

        form.classList.add('error');

        if(formStatusError && subscribeResponseError){
            subscribeResponseError.classList.add('active');
            formStatusError.innerHTML = data.msg;
            if(subscribeResponseSuccess){
                subscribeResponseSuccess.classList.remove('active');
            }
        }

        setTimeout(() => {
            form.classList.remove('error');
            if(formStatusError && subscribeResponseError){
                subscribeResponseError.classList.remove('active');
                formStatusError.innerHTML = '';
            }
        }, 5000);
    }

    };
  })
}